
import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { PasswordHintQuestionEntity, SubmitRequiredUserInformationRequestModel, SubmitRequiredUserInformationResponseModel } from '../../model/models';


@Injectable()
export class FirstTimeLoginService {
 

  constructor( private http : HttpClient) {  }

    getPwdHintQuestionList(){
      return this.http.get<Array<PasswordHintQuestionEntity>>(environment.server_url+"/api/PasswordHintQuestion");
    }

    firstTimeLogin(submitRequiredUserInfo:SubmitRequiredUserInformationRequestModel){
      return this.http.post<SubmitRequiredUserInformationResponseModel>(environment.server_url+"/api/RequiredUserInformation",submitRequiredUserInfo);
    }
}



// WEBPACK FOOTER //
// ./src/app/login/first-time-login/firstTimeLogin.service.ts